import styled from 'styled-components';
import { media } from 'styled-bootstrap-grid';

export const Title = styled.h3`
  font-size: 18px;
  font-family: ${({ theme }) => theme.headerFont};
  font-weight: ${({ theme }) => theme.fontWeights.bold};
  margin: 20px 0 10px 0;
`;

export const Container = styled.section`
  display: grid;
  grid-gap: 20px;
  grid-template-columns: 1fr;

  ${media.tablet`
    grid-template-columns: repeat(2, 1fr);
  `}

  ${media.lg`
    grid-template-columns: repeat(3, 1fr);
  `}
`;
